import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles/filterStyles.module.css';
import { FaDownload } from 'react-icons/fa';

import { downloadLogData } from '../../api/dataProcessing/post';
import { ClockLoader } from 'react-spinners';

const VisitorFields: React.FC<any> = ({ visitorType, setVisitorType }) => {
  return (
    <div className={styles.dropdownContainer}>
      <p style={{ marginRight: '13%' }} className={styles.description}>
        Data Filter:
      </p>
      <select
        onChange={(e) => setVisitorType(e.target.value)}
        value={visitorType || ''}
        className={styles.dropdown}
      >
        <option value="">-- Select Visitor Type --</option>{' '}
        {/* ⬅️ Empty initial option */}
        <option value="ALL_VISITORS">All Visitors</option>
        <option value="STAFF">Staff</option>
        <option value="GUEST">Guests</option>
        <option value="VENDOR">Vendors</option>
      </select>
    </div>
  );
};

const FilterAndExport: React.FC<any> = () => {
  const [typeSelection, setTypeSelection] = useState('ACTIVITY_LOG');
  const [visitorType, setVisitorType] = useState(null);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  //   const [emailFields, setEmailFields] = useState([{ value: '', isValid: true }]);
  //   const [showEmailPopover, setShowEmailPopover] = useState(false);

  useEffect(() => {
    if (typeSelection !== 'VISITOR_LOG') {
      setVisitorType(null);
    }
  }, [typeSelection]);

  function returnOptionalFields() {
    switch (typeSelection) {
      case 'VISITOR_LOG':
        return (
          <VisitorFields
            visitorType={visitorType}
            setVisitorType={setVisitorType}
          />
        );
      default:
        return null;
    }
  }

  //   function validateEmail(email: string) {
  //   const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   return regex.test(email);
  // }

  // function handleEmailChange(index: number, value: string) {
  //   const updated = [...emailFields];
  //   updated[index].value = value;
  //   updated[index].isValid = validateEmail(value);
  //   setEmailFields(updated);
  // }

  // function addEmailField() {
  //   setEmailFields([...emailFields, { value: '', isValid: true }]);
  // }

  async function downloadData() {
    // Check for missing dates

    if (!fromDate || !toDate) {
      alert('Please select both From and To dates.');
      return;
    }

    // Check for missing visitor type if type is "VISITOR LOG"
    if (typeSelection === 'VISITOR_LOG' && !visitorType) {
      alert('Please select a visitor sub-type before downloading.');
      return;
    }

    try {
      setDownloadLoading(true);
      const payload = {
        dataType: typeSelection,
        visitorSubType: visitorType,
        from: fromDate,
        to: toDate,
      };

      const resp = await downloadLogData(payload);

      if (resp) {
        const blob = new Blob([resp.data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `log_data_${new Date().toISOString()}.docx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      alert('Something went wrong');
    } finally {
      setDownloadLoading(false);
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.dividerLine}></div>
      <p className={styles.headline}>Filter & Export Tools</p>

      <div className={styles.dropdownContainer}>
        <p className={styles.description}>Filter by Type:</p>
        <select
          onChange={(e) => setTypeSelection(e.target.value)}
          value={typeSelection}
          className={styles.dropdown}
        >
          <option value="ACTIVITY_LOG">Activity Log</option>
          <option value="VISITOR_LOG">Visitor Log</option>
          <option value="PRINCIPAL_MOVEMENTS">Principal Movements</option>
          <option value="PROTECTOR_ROUNDS">Protector Rounds</option>
        </select>
      </div>
      {returnOptionalFields()}
      <div className={styles.dropdownContainer}>
        <p className={styles.description}>Date Range:</p>
        <div className={styles.dateRangeInputs}>
          <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            selectsStart
            startDate={fromDate}
            endDate={toDate}
            placeholderText="From"
            className={styles.datePickerInput}
            maxDate={toDate || new Date()}
          />

          <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            selectsEnd
            startDate={fromDate ?? undefined}
            endDate={toDate ?? undefined}
            minDate={fromDate ?? undefined}
            maxDate={new Date()}
            placeholderText="To"
            className={styles.datePickerInput}
          />
        </div>
      </div>
      <div className={styles.dividerLine}></div>
      <div className={styles.downloadWrapper}>
        <div
          onClick={() => {
            //don't allow click while it's loading
            if (downloadLoading) return;
            downloadData();
          }}
          className={styles.downloadCommandContainer}
        >
          {!downloadLoading ? (
            <FaDownload className={styles.exportLogo} />
          ) : (
            <ClockLoader size={22} className={styles.exportLogo} />
          )}
          <p className={styles.exportDescription}>Download Report</p>
        </div>

        {/* <div className={styles.downloadCommandContainer} onClick={() => {
  setShowEmailPopover(!showEmailPopover);
 
}}>
  <MdEmail className={styles.exportLogo} />
  <p className={styles.exportDescription}>Email Report</p>
</div> */}

        {/* 
{showEmailPopover && (
  <div className={styles.popover}>
    <p className={styles.popoverTitle}>Email Report</p>

    {emailFields.map((field, index) => (
      <input
        key={index}
        className={`${styles.inputElement} ${!field.isValid ? styles.invalid : ''}`}
        placeholder="Email Address"
        value={field.value}
        onChange={(e) => handleEmailChange(index, e.target.value)}
      />
    ))}

    <button type="button" className={styles.addButton} onClick={addEmailField}>
      + Add Email
    </button>
    <button>
        Submit
    </button>
  </div>
)} */}
      </div>
    </div>
  );
};

export default FilterAndExport;
